module.exports = __webpack_public_path__ + "img/ksxq@2x.2b12c1ec.png";